/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

import { Box } from "@mui/material";
import { PropsWithChildren } from "react";

export default function Row({ children, ...props }: PropsWithChildren<{}>) {
  return (
    <Box component ="div" {...props} 
    display="flex"
    sx={{justifyContent: 'flex-start',
      '& > :not(style)': { my: 1, marginRight: 2 }}}>
      {children}
    </Box>
  )
}